import React from 'react';
import PropTypes from 'prop-types';
import styles from './CalEmbed.module.css';

const CalEmbed = ({ calLink }) => {
  if (!calLink) {
    return null;
  }

  return (
    <div className={styles.embedContainer}>
      <iframe
        src={`https://cal.com/${calLink}`}
        width="100%"
        height="600"
        frameBorder="0"
        title="Calendar"
      />
    </div>
  );
};

CalEmbed.propTypes = {
  calLink: PropTypes.string,
};

CalEmbed.defaultProps = {
  calLink: null,
};

export default CalEmbed;